var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import React from 'react';
import { LemoneroAccountsLoginView } from './views/view';
import { LemoneroStyle } from "../../shared/components/lemonero.style";
export var LemoneroAccountsLogin = function (props, queryString) {
    console.debug(props, queryString);
    var element = document.querySelector(queryString);
    if (element == null)
        return;
    element.style.display = 'block';
    element.style.height = '100%';
    var root = createRoot(element);
    root.render(_jsxs(React.StrictMode, { children: [_jsx(LemoneroAccountsLoginView, __assign({}, props)), _jsx(LemoneroStyle, {})] }));
};
//# sourceMappingURL=index.js.map